/**
 * Wspólne wiązanie pól cyfrowych na WSZYSTKICH formularzach.
 * Wykrywa pola po name / id / wire:model* (także Livewire bez name).
 */

const { bindNipInput, initNipDigits } = require('./nip-digits');
const { bindPhoneInput, initPhoneDigits } = require('./phone-digits');
const { bindPostalCodeInput, initPostalCodeLookup } = require('./postal-code-lookup');

function fieldTokens(input) {
    return [
        input.getAttribute('name'),
        input.getAttribute('id'),
        input.getAttribute('wire:model'),
        input.getAttribute('wire:model.live'),
        input.getAttribute('wire:model.defer'),
        input.getAttribute('wire:model.blur'),
        input.getAttribute('wire:model.lazy'),
    ]
        .filter(Boolean)
        .map((v) => String(v).toLowerCase());
}

function lastSegment(token) {
    const parts = token.split(/[.\[]/);
    return parts[parts.length - 1].replace(/\]$/, '');
}

function tokenMatches(tokens, needles) {
    return tokens.some((t) => {
        const last = lastSegment(t);
        return needles.some((needle) => t === needle || last === needle || t.endsWith('_' + needle));
    });
}

function scanAndBind(root, needles, className, bindFn) {
    root.querySelectorAll('input').forEach((input) => {
        if (['hidden', 'checkbox', 'radio', 'submit', 'button', 'file'].includes(input.type)) {
            return;
        }
        if (input.classList.contains(className) || tokenMatches(fieldTokens(input), needles)) {
            input.classList.add(className);
            bindFn(input);
        }
    });
}

function initDigitFields(root = document) {
    scanAndBind(root, ['nip', 'nip1', 'nip2'], 'js-nip-digits', bindNipInput);
    scanAndBind(root, ['telephone', 'telefon'], 'js-phone-digits', bindPhoneInput);
    scanAndBind(
        root,
        ['kodpocztowy', 'kodpocztowy1', 'kodpocztowy2'],
        'js-postal-code-lookup',
        bindPostalCodeInput
    );

    // Legacy selektory (type=tel, autocomplete=postal-code, klasy).
    initNipDigits(root);
    initPhoneDigits(root);
    initPostalCodeLookup(root);
}

module.exports = {
    initDigitFields,
};
